import React, { useMemo } from 'react';

const StarField = () => {
  const stars = useMemo(() =>
    Array.from({ length: 120 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      size: Math.random() * 2 + 0.5,
      duration: `${2 + Math.random() * 4}s`,
      delay: `${Math.random() * 4}s`,
      opacity: Math.random() * 0.6 + 0.1,
    })), []
  );

  return (
    <div className="starfield">
      {stars.map(s => (
        <div
          key={s.id}
          className="star"
          style={{
            left: s.left,
            top: s.top,
            width: s.size,
            height: s.size,
            opacity: s.opacity,
            '--d': s.duration,
            animationDelay: s.delay,
          }}
        />
      ))}
    </div>
  );
};

export default StarField;
